import { Outlet } from 'react-router-dom';
import IncidentsHeaderNav from '../../components/HeadersNav/IncidentsHeaderNav';

const IncidentsPage = () => {
  return (
    <>
      <IncidentsHeaderNav />
      <Outlet />
    </>
  );
};

export default IncidentsPage;
